module.exports = __webpack_public_path__ + "img/red-left.0fed77a4.png";